module.exports = __webpack_public_path__ + "img/5.9fcae6c1.png";